export default async function getSubscription(fetch) {
    const resp = await fetch('/graphql', {
        body: JSON.stringify({
            query: '{subscription{id, cancelUrl, updateUrl, nextBillDate}}',
        }),
    });

    const { data } = await resp.json();

    if (!data || !data.subscription) {
        return null;
    }

    return data.subscription;
}